module.exports = __webpack_public_path__ + "img/icon-delete-5.60377498.svg";